import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import "../../style/pages.css";
import "./Register.css";

const initialForm = {
  survivorId: "",
  name: "",
  camp: "GB-33-A",
  role: "생존자",
  bloodType: "미상",
  password: "",
  passwordConfirm: "",
};

export default function Register() {
  const { user, checking, register } = useAuth();
  const [form, setForm] = useState(initialForm);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!checking && user) return <Navigate to="/" replace />;

  const update = (key) => (event) => setForm((current) => ({ ...current, [key]: event.target.value }));

  const submit = async (event) => {
    event.preventDefault();
    setError("");

    if (!/^S-\d{5}$/.test(form.survivorId)) {
      setError("생존자 ID는 S-00000 형식으로 입력하십시오.");
      return;
    }
    if (form.password.length < 8) {
      setError("접속 암호는 8자 이상이어야 합니다.");
      return;
    }
    if (form.password !== form.passwordConfirm) {
      setError("암호 확인이 일치하지 않습니다.");
      return;
    }

    setSubmitting(true);
    try {
      const { passwordConfirm, ...registration } = form;
      await register(registration);
      navigate("/", { replace: true });
    } catch (registrationError) {
      setError(registrationError.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="register-page">
      <section className="register-panel">
        <header>
          <p className="eyebrow">CHIKITOKA / SURVIVOR ENROLLMENT</p>
          <h1>신규 생존자 등록</h1>
          <p>확인 가능한 신원 정보만 입력하십시오. 등록 즉시 보안등급 1이 부여됩니다.</p>
        </header>
        <form onSubmit={submit}>
          <div className="register-grid">
            <div className="field"><label htmlFor="register-id">생존자 ID</label><input id="register-id" value={form.survivorId} onChange={update("survivorId")} placeholder="S-00000" pattern="S-[0-9]{5}" maxLength="7" autoComplete="username" required /></div>
            <div className="field"><label htmlFor="register-name">이름</label><input id="register-name" value={form.name} onChange={update("name")} minLength="2" maxLength="40" required /></div>
            <div className="field"><label htmlFor="register-camp">소속 캠프</label><input id="register-camp" value={form.camp} onChange={update("camp")} maxLength="40" required /></div>
            <div className="field"><label htmlFor="register-role">역할</label><select id="register-role" value={form.role} onChange={update("role")}><option>생존자</option><option>정찰대</option><option>의료반</option><option>보급반</option><option>통신반</option><option>경비대</option></select></div>
            <div className="field"><label htmlFor="register-blood">혈액형</label><select id="register-blood" value={form.bloodType} onChange={update("bloodType")}><option>미상</option><option>A+</option><option>A-</option><option>B+</option><option>B-</option><option>O+</option><option>O-</option><option>AB+</option><option>AB-</option></select></div>
            <div className="register-clearance"><span>초기 보안 등급</span><strong>LEVEL 1</strong></div>
            <div className="field"><label htmlFor="register-password">접속 암호</label><input id="register-password" type="password" value={form.password} onChange={update("password")} minLength="8" maxLength="72" autoComplete="new-password" required /></div>
            <div className="field"><label htmlFor="register-password-confirm">접속 암호 확인</label><input id="register-password-confirm" type="password" value={form.passwordConfirm} onChange={update("passwordConfirm")} minLength="8" maxLength="72" autoComplete="new-password" required /></div>
          </div>
          {error && <div className="login-error" role="alert">! {error}</div>}
          <button className="register-submit" type="submit" disabled={submitting}>{submitting ? "생존 기록 등록 중..." : "생존 기록 등록"}</button>
        </form>
        <div className="auth-switch">이미 등록된 생존자입니까? <Link to="/login">[인증 화면으로 복귀]</Link></div>
      </section>
    </main>
  );
}
